module.exports = __webpack_public_path__ + "static/media/icon.9c2da96a.png";